import type { MembershipProduct, SpaceProfile } from "../SpaceType";
import { membershipListIconUrl } from "../spacePageUtils";
import { SpaceHomeMembershipSection } from "../components/SpaceHomeMembershipSection";

export function SpaceHomeMembershipListItem(props: {
  spaceId: string;
  row: MembershipProduct;
  isLoggedIn: boolean;
  onLoginRequest: () => void;
  spaceProfile: SpaceProfile | null;
  onSubscribePrimaryClick?: () => void;
}): JSX.Element {
  const {
    spaceId,
    row,
    isLoggedIn,
    onLoginRequest,
    spaceProfile,
    onSubscribePrimaryClick,
  } = props;
  const cardIcon = membershipListIconUrl(row);
  const isBundle = row.productKind === "product_bundle";
  return (
    <li
      className={
        isBundle
          ? "space-membership-item space-membership-item--bundle"
          : "space-membership-item"
      }
    >
      <div className="space-m-body">
        {cardIcon ? (
          <div className="space-m-icon-wrap">
            <img
              className="space-m-icon"
              src={cardIcon}
              alt=""
              width={56}
              height={56}
              loading="lazy"
              decoding="async"
            />
          </div>
        ) : null}
        <div className="space-m-copy">
          <div className="space-membership-name">{row.displayName}</div>
          <p className="space-membership-intro">{row.description}</p>
        </div>
        <div className="space-membership-right">
          <SpaceHomeMembershipSection
            spaceId={spaceId}
            row={row}
            isLoggedIn={isLoggedIn}
            onLoginRequest={onLoginRequest}
            spaceProfile={spaceProfile}
            onSubscribePrimaryClick={onSubscribePrimaryClick}
          />
        </div>
      </div>
    </li>
  );
}
